import { render, staticRenderFns } from "./substituteDrivingDispatch.vue?vue&type=template&id=4523c972&scoped=true&"
import script from "./substituteDrivingDispatch.vue?vue&type=script&lang=js&"
export * from "./substituteDrivingDispatch.vue?vue&type=script&lang=js&"
import style0 from "./substituteDrivingDispatch.vue?vue&type=style&index=0&id=4523c972&scoped=true&lang=css&"
import style1 from "./substituteDrivingDispatch.vue?vue&type=style&index=1&lang=css&"
import style2 from "./substituteDrivingDispatch.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4523c972",
  null
  
)

export default component.exports